module.exports = __webpack_public_path__ + "20746430f6db96dd960d2d42640ca3b3.fbx";